require('../../../modules/es7.array.includes');
module.exports = require('../../../modules/_entry-virtual')('Array').includes;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/array/virtual/includes.js
// module id = d4Wg
// module chunks = 0